import ContentfulImageRenderer from 'contentful/image_renderer';

const ImageGrid = ({ data, perRow = 4 }) => {
  const { title, gridItems } = data;
  return (
    <>
      {title && <h2>{title}</h2>}
      <div className={`image-grid image-grid--grid-${perRow}`}>
        {gridItems.map(
          ({ fields: { image, title: itemTitle, description } = {}, sys }) => (
            <div className="image-grid__item" key={sys.id}>
              {image && !!Object.keys(image).length && (
                <div className="image-grid__item-image">
                  <ContentfulImageRenderer image={image} />
                </div>
              )}
              <h4>{itemTitle}</h4>
              <p>{description}</p>
            </div>
          ),
        )}
      </div>
    </>
  );
};

export default ImageGrid;
